<template>
<div class="hover-menu">
  <div class="handle-icon" >
    
    <div style="margin-bottom: 24px" @click="$emit('allScreen')">
      <div class="menu">
        <i class="iconfont" :class="isAllScreen ? 'icona-10quanping-xiao' : 'iconquanping1'"></i>
      </div>
    </div>
    <div style="margin-bottom: 24px" @click="$emit('addReport')" v-show="showAdd">
      <div class="menu" style="background: #fe9d3e">
        <i class="iconfont iconadd2"></i>
      </div>
    </div>
    <!-- <el-popover placement="left-end" trigger="hover" v-show="$slots.add">
      <div class="list">
        <slot name="add"></slot>
      </div>
      <div style="margin-bottom:24px" slot="reference">
        <div class="menu" style="background:#FE9D3E">
          <i class="iconfont iconadd2"></i>
        </div>
      </div>
    </el-popover> -->
    <el-popover :appendToBody="false" :popperOptions="popperOptions" placement="left-end" trigger="hover" v-show="$slots.menu">
      <div class="list">
        <slot name="menu"></slot>
      </div>
      <div slot="reference">
        <div class="menu">
          <i class="iconfont icona-07gengduo"></i>
        </div>
      </div>
    </el-popover>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isAllScreen: {
      type: Boolean,
      default: false,
    },
    showAdd: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      popperOptions: {
        boundariesElement: '.handle-icon'
      }
    }
  }
}
</script>
<style lang="scss">
.custom-scroll-wrap {
  &:hover {
    .handle-icon {
     right: 4px!important;
    }
  }
}
</style>
<style lang="scss" scoped>
@function trl($px: 14px) {
  @return ($px * 100vw)/ 1440px;
}
@function trlh($px: 14px) {
  @return ($px * 100vh)/ 840px;
}
.handle-icon {
  transition:  all 0.8s;
  position: fixed;
  bottom:  trl(40px);
  right: trl(-44px);
  z-index: 2004;
  font-size:  trl(-16px);;
  cursor: pointer;
  color: #010517;
  &.act {

  }
   
  .menu {
    background: #0560fd;
    color: #fff;
    display: flex;

    align-items: center;
    justify-content: center;
    width: trl(30px);
    height: trlh(30px);
    border-radius:  trl(4px);
    box-shadow: 0px trl(2px) trlh(10px) 0px rgba(0, 0, 0, 0.15);
    i {
      font-size: trl(16px) !important;
    }
    &:hover {
      opacity: 0.75;
    }
  }
}
  

.list {
  max-height: trlh(270px);
  overflow: auto;
  //   border-radius: 6px;
  padding: 8px;
  display: flex;
  flex-direction: column;
  /deep/ li {
    display: flex;
    align-items: center;
    cursor: pointer;
    font-size: 14px;
    .icon {
      display: flex;
      flex: 0 0 auto;
      align-items: center;
      justify-content: center;
      width: trl(32px);
      height:  trlh(32px);
      font-size:  trl(16px);
      color: #010517;
      border-radius: 50%;
      background: #eff0f2;
      margin-right:  trl(12px);;
      i {
        font-size:  trl(18px) !important;
      }
    }
    /deep/ span {
      white-space: nowrap;
    }
  }
  /deep/ li + li {
    margin-top:  trlh(20px);;
  }
}
.hover-menu {
  position: relative;

}
</style>
